import {useLayoutEffect, useRef, useState} from "react";
import {sanitizeHtml} from "@/utils/utils.ts";

import type { AccordionStyle, StaticContent } from '@/types/types.ts';

interface CalloutProps {
    contentData: StaticContent
}
export default function Callout({contentData}: CalloutProps) {

    /* States and interactivity needed for the accordion */
    const [height, setHeight] = useState(0);
    const contentRef = useRef<HTMLDivElement | null>(null)
    const [calloutOpen, setCalloutOpen] = useState(false);

    useLayoutEffect(() => {
        if (!contentRef.current) {
            return
        }

        setHeight(contentRef.current.scrollHeight)
    }, [contentData?.callout]);
    return (
        <div className="policy-library-callout">
        <h2>{contentData?.callout?.title ? contentData.callout.title : 'Glossary of Terms'}</h2>
        <button className="policy-library-callout-accordion-btn"
                aria-controls="policy-library-callout-content" aria-expanded={calloutOpen}
                onClick={() => setCalloutOpen((open) => !open)}>
            {contentData?.callout?.title ? contentData.callout.title : 'Glossary of Terms'}
            <span className="Accordion__icon"><svg width="22" height="22" fill="none"><g fill="#333"><path
                d="M9 2h4v18H9z"></path><path d="M20 9v4H2V9z"></path></g></svg></span>
        </button>
        <div className="policy-library-callout-accordion" id="policy-library-callout-content"
             ref={contentRef} style={{
            '--height': `${height}px`
        } as AccordionStyle}>
            {contentData?.callout?.content && (
                <div dangerouslySetInnerHTML={sanitizeHtml(contentData.callout.content)}/>)}
            {!!contentData?.callout?.links?.length && (
                <ul>
                    {contentData.callout.links.map((link, index) => (
                        <li key={index}>
                            <a href={link?.url ?? "#"} className="Link--shake"
                               target={link?.target ?? undefined}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="19">
                                    <path
                                        d="m8.889 8.527-5.171 8.528A15.567 15.567 0 0 1 0 15.333l4.128-6.806L0 1.722A15.735 15.735 0 0 1 3.718 0l5.17 8.527Z"></path>
                                </svg>
                                <span dangerouslySetInnerHTML={sanitizeHtml(link.title)} /></a>
                        </li>))}
                </ul>)}
        </div>
    </div>
    )
}